import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

export type ContainerPlanningSymbolType =
  | "empty"
  | "adn"
  | "reefer"
  | "heavy";

export const AdnAdrSymbol: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 128 128">
    <rect
      x="18"
      y="25"
      width="92"
      height="78"
      rx="8"
      fill="#F97316"
      stroke="#111827"
      strokeWidth="6"
    />
    <path d="M18 64h92" stroke="#111827" strokeWidth="6" />
  </SvgIcon>
);

export const EmptyContainerSymbol: React.FC<SvgIconProps & { strokeColor?: string }> = ({ strokeColor = "#6B7280", ...props }) => (
  <SvgIcon {...props} viewBox="0 0 128 128">
    <rect
      x="20"
      y="18"
      width="88"
      height="92"
      rx="8"
      fill="none"
      stroke={strokeColor}
      strokeWidth="7"
    />
    <path
      d="M47 42h38M47 42v44M47 64h31M47 86h38"
      fill="none"
      stroke={strokeColor}
      strokeWidth="9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const HeavyContainerSymbol: React.FC<SvgIconProps & { strokeColor?: string }> = ({ strokeColor = "#6D3CC2", ...props }) => (
  <SvgIcon {...props} viewBox="0 0 128 128">
    <path
      d="M48 30a16 16 0 1 1 32 0v8"
      fill="none"
      stroke={strokeColor}
      strokeWidth="8"
      strokeLinecap="round"
    />
    <path
      d="M31 39h66l14 59c2 7-3 13-10 13H27c-7 0-12-6-10-13l14-59z"
      fill={strokeColor}
    />
    <text
      x="64"
      y="84"
      textAnchor="middle"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="28"
      fontWeight="700"
      fill="#FFFFFF"
    >
      KG
    </text>
  </SvgIcon>
);

export const ReeferContainerSymbol: React.FC<SvgIconProps & { strokeColor?: string }> = ({ strokeColor = "#1756B3", ...props }) => (
  <SvgIcon {...props} viewBox="0 0 128 128">
    <g
      fill="none"
      stroke={strokeColor}
      strokeWidth="7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M27 18v56a20 20 0 1 0 24 0V18a12 12 0 0 0-24 0z" />
      <path d="M39 34v49" />
      <circle cx="39" cy="89" r="9" fill={strokeColor} stroke="none" />
      <path d="M51 30h12M51 43h10M51 56h12M51 69h10" />
      <path d="M90 39v48M70 51l40 24M70 75l40-24" />
      <path d="M90 39l-6 8M90 39l6 8M90 87l-6-8M90 87l6-8" />
      <path d="M70 51l10 1M70 51l4 9M110 75l-10-1M110 75l-4-9" />
      <path d="M70 75l10-1M70 75l4-9M110 51l-10 1M110 51l-4 9" />
    </g>
  </SvgIcon>
);

interface ContainerPlanningSymbolProps extends SvgIconProps {
  type: ContainerPlanningSymbolType;
  strokeColor?: string;
}

export const ContainerPlanningSymbol: React.FC<
  ContainerPlanningSymbolProps
> = ({ type, strokeColor, ...props }) => {
  switch (type) {
    case "adn":
      return <AdnAdrSymbol {...props} />;
    case "reefer":
      return <ReeferContainerSymbol {...props} strokeColor={strokeColor} />;
    case "heavy":
      return <HeavyContainerSymbol {...props} strokeColor={strokeColor} />;
    default:
      return <EmptyContainerSymbol {...props} strokeColor={strokeColor} />;
  }
};

